import { DataGridColSettings } from '@/components/DataGrid/utils';

// Navigation tabs for Internal Affairs edit/new pages
export const internalAffairsNavTabs = [
  { path: 'overview', label: 'Overview' },
  { path: 'people-involved', label: 'People involved' },
  { path: 'related-records', label: 'Related records' },
];

// Navigation tabs for Internal Affairs view pages (includes audit trail)
export const internalAffairsViewNavTabs = [
  { path: 'overview', label: 'Overview' },
  { path: 'people-involved', label: 'People involved' },
  { path: 'related-records', label: 'Related records' },
  { path: 'audit-trail', label: 'Audit trail' },
];

// Accepted file types for Internal Affairs file uploads
export const IAFileAcceptedTypes = {
  'image/jpeg': [],
  'image/png': [],
  'video/mp4': [],
  'video/webm': [],
  'application/pdf': [],
  'application/msword': [],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
  'text/csv': [],
  'text/plain': [],
  'application/vnd.ms-excel': [],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
};

// You can use this later for filters / selects if needed
export const isCaseTypes = [
  'Use of Force',
  'Harassment',
  'Corruption',
  'Policy Violation',
  'Conduct Unbecoming',
  'Data Privacy Breach',
] as const;

export const isCaseStatuses = ['Open', 'In Progress', 'Closed'] as const;

// Person involvement types
export const involvementTypes = [
  'Subject',
  'Complainant',
  'Witness',
  'Investigating Officer',
  'Supervisor',
] as const;

// Data source types
export const dataSourceTypes = [
  'Internal Database',
  'Manual Entry',
  'External System',
  'HR Records',
  'Citizen Report',
] as const;

export const InternalAffairsCasesTableColumns: DataGridColSettings[] = [
  {
    field: 'caseId',
    headerName: 'Case ID',
    width: 180,
    visible: true,
  },
  {
    field: 'officersWithAccess',
    headerName: 'Officer(s) with access',
    width: 260,
    visible: true,
  },
  {
    field: 'caseType',
    headerName: 'Case Type',
    width: 220,
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    visible: true,
  },
  {
    field: 'createdBy',
    headerName: 'Created By',
    width: 200,
    visible: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    width: 200,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];

// People Involved Table Columns - matches Master Index Person table
export const PeopleInvolvedTableColumns: DataGridColSettings[] = [
  {
    field: 'uniqueId',
    headerName: 'ID',
    width: 120,
    visible: true,
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 280,
    visible: true,
  },
  {
    field: 'address',
    headerName: 'Address',
    width: 280,
    visible: true,
  },
  {
    field: 'flags',
    headerName: 'Flags',
    width: 150,
    visible: true,
  },
  {
    field: 'phone',
    headerName: 'Phone number',
    width: 280,
    visible: true,
  },
  {
    field: 'licenseId',
    headerName: 'License ID',
    width: 180,
    visible: true,
  },
  {
    field: 'ethnicity',
    headerName: 'Ethnic Origin',
    width: 220,
    visible: true,
  },
  {
    field: 'race',
    headerName: 'Race',
    width: 180,
    visible: true,
  },
  {
    field: 'ssn',
    headerName: 'Social security number',
    width: 240,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];

// Related Records Table Columns
export const RelatedRecordsTableColumns: DataGridColSettings[] = [
  {
    field: 'recordNumber',
    headerName: 'Record number',
    visible: true,
  },
  {
    field: 'agency',
    headerName: 'Agency',
    visible: true,
  },
  {
    field: 'createdDate',
    headerName: 'Created date',
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];

// Record types
export const relatedRecordTypes = [
  'Criminal Case',
  'Traffic Incident',
  'Arrest Report',
  'Property Report',
  'Call for Service',
  'Incident Report',
] as const;

// Audit Trail Table Columns
export const AuditTrailTableColumns: DataGridColSettings[] = [
  {
    field: 'createdAt',
    headerName: 'Created at',
    width: 200,
    visible: true,
  },
  {
    field: 'event',
    headerName: 'Event',
    width: 200,
    visible: true,
  },
  {
    field: 'field',
    headerName: 'Field',
    width: 200,
    visible: true,
  },
  {
    field: 'value',
    headerName: 'Value',
    width: 250,
    visible: true,
  },
  {
    field: 'changedBy',
    headerName: 'Changed by',
    width: 200,
    visible: true,
  },
  {
    field: 'triggeredBy',
    headerName: 'Triggered by',
    width: 200,
    visible: true,
  },
];

// Event types
export const auditEventTypes = [
  'Create',
  'Edit',
  'Status changes',
  'Permission grants',
  'Deletions',
  'File upload',
  'Comment added',
  'Assignment change',
] as const;
